import type { MultiMeterBarChartTooltipProps } from '../types/multi-meter-bar-chart.js';

export const Tooltip = (props: MultiMeterBarChartTooltipProps) => null;

Tooltip['displayName'] = 'MeterBarChart.Tooltip';
